import { render, staticRenderFns } from "./PttButton.vue?vue&type=template&id=c1180a1a&scoped=true&lang=pug&"
import script from "./PttButton.vue?vue&type=script&lang=js&"
export * from "./PttButton.vue?vue&type=script&lang=js&"
import style0 from "./PttButton.vue?vue&type=style&index=0&id=c1180a1a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1180a1a",
  null
  
)

export default component.exports